export default __webpack_public_path__ + "static/media/dropbox.dffeb9b8.svg";